// extracted by mini-css-extract-plugin
export default {"normal":"pKjc9p","bold":"U70TRS","black":"jjdzq5","dynamicBold":"m_li4Y"};